import type { Zone } from '@/types';

export const ZONES: Zone[] = [
  { id: 'chest',     n: 'Pectoraux', emoji: '🛡️' },
  { id: 'back',      n: 'Dos',       emoji: '🔙' },
  { id: 'shoulders', n: 'Épaules',   emoji: '🤸' },
  { id: 'arms',      n: 'Bras',      emoji: '💪' },
  { id: 'abs',       n: 'Abdos',     emoji: '🟫' },
  { id: 'quads',     n: 'Cuisses',   emoji: '🦵' },
  { id: 'glutes',    n: 'Fessiers',  emoji: '🍑' },
  { id: 'calves',    n: 'Mollets',   emoji: '🦶' },
];
